import { render, staticRenderFns } from "./AppOpenLayout.vue?vue&type=template&id=36c0550a&scoped=true&"
import script from "./AppOpenLayout.vue?vue&type=script&lang=js&"
export * from "./AppOpenLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppOpenLayout.vue?vue&type=style&index=0&id=36c0550a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c0550a",
  null
  
)

export default component.exports